var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0659,
    r: 24,
    fill: "#FFACAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7071 24.773C33.0976 24.3825 33.0976 23.7493 32.7071 23.3588L26.3431 16.9949C25.9526 16.6043 25.3195 16.6043 24.9289 16.9949C24.5384 17.3854 24.5384 18.0185 24.9289 18.4091L30.5858 24.0659L24.9289 29.7228C24.5384 30.1133 24.5384 30.7465 24.9289 31.137C25.3195 31.5275 25.9526 31.5275 26.3431 31.137L32.7071 24.773ZM15 25.0659H32V23.0659H15V25.0659Z",
    fill: "#1D2130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.17ae0c8e4f960842e66fb8714abb4792.svg";
export { ForwardRef as ReactComponent };